<template>
  <div class="map-container">
     <iframe src="https://oommur-pluto.ctnaval.com" title="Plataforma Entrenamiento Vehículo Autónomo" width="100%" height="100%" style="border:none;"></iframe> 
  </div>
</template>

<script>
export default {
  name: "Pluto",
  data() {
    return {
    };
  },
  mounted () {
  },
  methods: {      
  }
  
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pluto.vue